import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'
import { Dialog } from 'components/ds'

import MailingListForm from './form'

const ContactsMailingListEdit = (): React.ReactNode => {
  const navigate = useNavigate()
  const params = useParams<{ listId?: string }>()
  const title = params.listId ? 'Edit Mailing List' : 'Create Mailing List'

  return (
    <>
      <DocumentHeadTags title={`${title} | DISCO`} />
      <Dialog.Root
        open
        onOpenChange={open => {
          // Matches the form's own Cancel button, so every dismissal path
          // (Escape, overlay click, Cancel) lands back on the table this
          // dialog opened over instead of jumping to a different page.
          if (!open) navigate('/lists')
        }}
      >
        <Dialog.Content maxWidth="500px" aria-describedby={undefined}>
          <Dialog.Title>{title}</Dialog.Title>
          <MailingListForm />
        </Dialog.Content>
      </Dialog.Root>
    </>
  )
}

export default ContactsMailingListEdit
